module.exports = __webpack_public_path__ + "static/media/signout.522d0984.svg";